<template>
  <!--
    Uma célula da folha `public/ui/bandeiras-de-pais.png`. `role="img"` + nome no `aria-label` e no
    `title`: a bandeira sozinha não diz o país a quem não a conhece — Chade e Romênia são a mesma
    arte a 24px.
  -->
  <span
    v-if="nome"
    class="bandeira-de-pais"
    role="img"
    :aria-label="nome"
    :title="nome"
    :style="estilo"
  />
</template>

<script>
import {
  ALTURA_DA_BANDEIRA,
  COLUNAS_DA_FOLHA,
  LARGURA_DA_BANDEIRA,
  LINHAS_DA_FOLHA,
} from './paises.gerado';
import { POSICAO_NA_FOLHA, nomeDoPais } from './paises';

/**
 * A BANDEIRA DE UM PAÍS (11/09/2026), recortada da folha de sprites.
 *
 * **Não é a bandeira do clã** (`ClanBandeira.vue`) — ver `paises.js`.
 *
 * `escala` é inteira de propósito: a arte tem 24×18 e é desenhada `pixelated`, e 1,5× faz metade
 * dos pixels ter o dobro da largura da outra metade. 1 na linha de uma lista, 2 no escolhedor, 3 no
 * cabeçalho do cais.
 *
 * Código fora da folha (um país que saiu da lista depois de gravado) não desenha nada, em vez de um
 * retângulo vazio — o servidor continua devolvendo o código, e é aqui que ele deixa de aparecer.
 */
export default {
  name: 'BandeiraDePais',
  props: {
    codigo: { type: String, default: null },
    escala: {
      type: Number,
      default: 1,
      validator: (n) => Number.isInteger(n) && n >= 1,
    },
  },
  computed: {
    nome() {
      return nomeDoPais(this.codigo, this.$i18n.locale, (chave) => this.$t(chave));
    },
    estilo() {
      const i = POSICAO_NA_FOLHA.get(this.codigo);
      const e = this.escala;
      const coluna = i % COLUNAS_DA_FOLHA;
      const linha = Math.floor(i / COLUNAS_DA_FOLHA);
      return {
        width: `${LARGURA_DA_BANDEIRA * e}px`,
        height: `${ALTURA_DA_BANDEIRA * e}px`,
        backgroundSize: `${COLUNAS_DA_FOLHA * LARGURA_DA_BANDEIRA * e}px ${LINHAS_DA_FOLHA * ALTURA_DA_BANDEIRA * e}px`,
        backgroundPosition: `-${coluna * LARGURA_DA_BANDEIRA * e}px -${linha * ALTURA_DA_BANDEIRA * e}px`,
      };
    },
  },
};
</script>

<style scoped>
.bandeira-de-pais {
  display: inline-block;
  flex: none;
  vertical-align: middle;
  background-image: url('/ui/bandeiras-de-pais.png');
  background-repeat: no-repeat;
  image-rendering: pixelated;
  /* O fio de tinta é o que separa do papel as bandeiras de fundo branco — Japão, Canadá, Coreia. */
  outline: 1px solid var(--tinta-fraca);
}
</style>
